import { AppUserType } from '~/enums/permissions/_types';

export default () => {
    const { can } = usePermissions();

    return {
        canOverview: () => can(AppUserType.Admin, AppUserType.Client, AppUserType.Approver),
    };
};
